import { getProductVertical } from "../constants/productVertical";
// ✅ Safe getter (works in Web + React Native)
const getWebEngage = () => {
    return globalThis?.webengage;
};
// ✅ Check readiness
const isWebEngageReady = () => {
    return !!getWebEngage();
};
// ✅ Retry helper (stub appears immediately from index snippet; real SDK loads async)
const waitForWebEngage = (callback, retries = 40) => {
    if (isWebEngageReady()) {
        callback();
    }
    else if (retries > 0) {
        setTimeout(() => waitForWebEngage(callback, retries - 1), 300);
    }
    else {
        console.warn("WebEngage not available after retries");
    }
};
const dispatchTrack = (eventName, data) => {
    try {
        // Stub queues until webengage-min loads; no need to wrap in onReady (see WebEngage web getting started).
        getWebEngage()?.track(eventName, data);
    }
    catch (e) {
        console.warn("[WebEngage] track failed:", eventName, e);
    }
};
/** Custom events — uses SDK command queue when the script is still loading. */
export const trackEvent = (eventName, data) => {
    waitForWebEngage(() => dispatchTrack(eventName, data));
};
// ✅ Login
export const loginUser = (userId) => {
    waitForWebEngage(() => {
        getWebEngage()?.user.login(userId);
    });
};
// ✅ Logout
export const logoutUser = () => {
    waitForWebEngage(() => {
        getWebEngage()?.user.logout();
    });
};
/** Browser storage without referencing global `localStorage` (RN / non-DOM TS builds). */
const getLocalStorageItem = (key) => {
    try {
        const ls = globalThis.localStorage;
        if (!ls || typeof ls.getItem !== "function")
            return null;
        return ls.getItem(key);
    }
    catch {
        return null;
    }
};
// ✅ Set User Attributes
export const setUserAttributes = (userData) => {
    waitForWebEngage(() => {
        const we = getWebEngage();
        if (!we)
            return;
        Object.entries(userData).forEach(([key, value]) => {
            we.user.setAttribute(key, value);
        });
    });
};
// ✅ Set Full Profile
export const setUserProfile = () => {
    waitForWebEngage(() => {
        const we = getWebEngage();
        if (!we)
            return;
        let authStorage = {};
        try {
            const raw = getLocalStorageItem("auth-storage");
            authStorage =
                raw && raw.trim() !== "" ? JSON.parse(raw) : {};
        }
        catch {
            authStorage = {};
        }
        const uad = authStorage?.state?.profilesData?.unified_account_details;
        const userDetails = uad?.user_account_details;
        const firstProfile = uad?.profiles?.[0];
        const unified_account_id = uad?.unified_account_id;
        // 1. Login
        we.user.login(unified_account_id);
        // ✅ Map attributes cleanly
        const attributes = {
            we_phone: `${userDetails?.isd_code}${userDetails?.phone}`,
            we_first_name: userDetails?.first_name,
            we_last_name: userDetails?.last_name,
            we_email: userDetails?.email,
            we_whatsapp_opt_in: userDetails?.whatsapp_consent ? true : false,
            we_sms_opt_in: true,
            we_email_opt_in: false,
            // user_type: data.userType,
            grade: userDetails?.grade?.gradeId,
            school_name: userDetails?.schoolName,
            target_exam: firstProfile?.exams?.map((e) => e?.name).join(","),
            product_vertical: getProductVertical(firstProfile?.vertical_id ?? 1),
            product_source: getProductVertical(firstProfile?.vertical_id ?? 1),
            lead_source: "IL Website",
            uam_id: firstProfile?.uam_id,
            last_consent_date: new Date(),
        };
        // ✅ Set attributes safely
        Object.entries(attributes).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                we.user.setAttribute(key, value);
            }
        });
    });
};
